/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据DICT_KEY获取数据字典
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  codeKey: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.GBdDictResponse>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/codeKey/${codeKey}/dicts`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
